import { render, staticRenderFns } from "./BalanceDistribution.vue?vue&type=template&id=05d7d934&scoped=true&"
import script from "./BalanceDistribution.vue?vue&type=script&lang=ts&"
export * from "./BalanceDistribution.vue?vue&type=script&lang=ts&"
import style0 from "./BalanceDistribution.vue?vue&type=style&index=0&id=05d7d934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d7d934",
  null
  
)

export default component.exports